export const SDK_VERSION = '7.42.0';
